export default {
  metadata: {
    version: '1.0.0',
    id: 'mega-menu-1.0.0',
    name: 'JDSMegaMenu',
    platform: 'web'
  },
  hierarchy: {
    popup: [
      {
        'popup-container': ['jds_megamenu_internal']
      }
    ]
  },
  base: {
    popup: {
      priority: 40,
      hidden: true,
      passive: true
    },
    'popup-container': {
      'flex-direction': '{m_0}'
    }
  },
  variant: {
    open: {
      true: {
        popup: {
          hidden: false
        }
      }
    }
  },
  api: {
    config: {
      open: {
        values: [false, true]
      }
    },
    data: {
      'popup-container': {
        'padding-top': {
          type: 'size',
          name: 'offsetY'
        },
        'padding-left': {
          type: 'size',
          name: 'offsetX'
        },
        width: {
          type: 'size',
          name: 'width'
        }
      },
      jds_megamenu_internal: {
        items: {
          type: 'list',
          name: 'items',
          object: {
            heading: 'string',
            subLinks: 'list'
          }
        },
        'items.heading': {
          type: 'string',
          name: 'items.heading'
        },
        'items.subLinks': {
          type: 'list',
          name: 'items.subLinks'
        }
      }
    },
    events: {
      jds_megamenu_internal: {
        onHoverEnd: 'onHoverEnd'
      }
    },
    a11y: {
      jds_megamenu_internal: {
        name: 'items',
        repeating: {
          ariaLabel: 'linkAriaLabel',
          ariaDescribedby: {
            name: 'linkAriaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
